<template>
  <div v-loading="loading">
    <el-card shadow="hover" class="platform-clock-in" v-if="show === 'preview'">
      <el-divider class="platform-clock-in-title">{{ title }}</el-divider>
      <div class="platform-clock-in-description">{{ description }}</div>
      <div class="platform-clock-in-content">
        我的感悟：
        <pre>{{ preview.text_content }}</pre>
      </div>
      <div class="platform-clock-in-images">
        <img
          class="platform-clock-in-images-item"
          v-for="(item, index) in preview.img_urls"
          :key="index"
          :src="item"
        />
      </div>
    </el-card>
    <el-card shadow="hover" class="platform-clock-in" v-if="show === 'submit'">
      <el-divider class="platform-clock-in-title">{{ title }}</el-divider>
      <div class="platform-clock-in-description">{{ description }}</div>
      <div class="platform-clock-in-content">
        <el-input
          v-model="submit.text_content"
          size="small"
          type="textarea"
          :rows="4"
          placeholder="快快输入你的学习感悟吧～"
        ></el-input>
      </div>
      <div class="platform-clock-in-images" v-loading="uploadLoading">
        <el-upload
          action=""
          accept="image/jpeg image/gif image/png"
          list-type="picture-card"
          :file-list="fileList"
          :on-preview="handleOnPreview"
          :before-upload="handleBeforeUpload"
          :on-remove="handleOnRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" />
        </el-dialog>
      </div>
      <div class="platform-clock-in-button">
        <el-button type="primary" size="small" plain @click="handleSubmit">
          提交
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import API from "@/global/requests/api";
import plusService from "@/global/services/jikerPlus";
import qiniuService from "@/global/services/qiniuPlus";

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    sourceId: {
      type: Number,
      required: true
    },
    projectId: {
      type: Number
    },
    title: {
      type: String
    },
    description: {
      type: String
    }
  },
  data() {
    return {
      loading: true,
      uploadLoading: false,
      show: "",
      preview: {
        text_content: "",
        img_urls: []
      },
      submit: {
        source: "kongfu",
        source_id: this.sourceId,
        project_id: this.projectId,
        project_content_id: this.id,
        text_content: "",
        img_urls: []
      },
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      plusService
        .showClockIn({
          source: "kongfu",
          source_id: this.sourceId,
          project_id: this.projectId,
          project_content_id: this.id
        })
        .then(res => {
          if (res.id) {
            this.show = "preview";
            this.preview = res;
          } else {
            this.show = "submit";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSubmit() {
      if (!this.submit.text_content || this.submit.img_urls.length === 0) {
        this.$message.error("感悟与图片都要输入才能打卡哦～");
        return;
      }
      this.loading = true;
      plusService
        .addClockIn(this.submit)
        .then(() => {
          this.$message.success("打卡成功～");
          this.getData();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleOnPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleBeforeUpload(file) {
      if (!file || !this.validateSize(file)) {
        return false;
      }
      const space = "_for_plus_sub_project";
      const folder = "web";
      const api = API.plusFile;
      this.uploadLoading = true;
      qiniuService
        .upload({ space, folder, file, api }, () => {})
        .then(res => {
          this.submit.img_urls.push(res.id);
          this.fileList.push(res);
        })
        .finally(() => {
          this.uploadLoading = false;
        });
      return false;
    },
    validateSize(file) {
      const size = 500 * 1024;
      const fileName = file.name;
      const suffix = fileName.split(".").pop();
      const imageRegex = /(jpg|gif|png)/;
      if (file.size > size || !imageRegex.test(suffix)) {
        this.$message.error(
          `请上传不大于 ${500}KB 且格式为jpg、gif、png 的文件`
        );
        return false;
      }
      return true;
    },
    handleOnRemove(file) {
      this.fileList.forEach((data, index, self) => {
        if (data.uid === file.uid) {
          self.splice(index, 1);
        }
      });
      this.submit.img_urls.forEach((data, index, self) => {
        if (data === file.id) {
          self.splice(index, 1);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.platform-clock-in {
  margin: 24px 0;
  padding: 16px 0;
  width: 100%;
  text-align: center;
  .platform-clock-in-title {
    display: inline-block;
    margin-bottom: 16px;
    width: 70%;
  }
  .platform-clock-in-description {
    font-size: 12px;
    color: #999;
  }
  .platform-clock-in-content,
  .platform-clock-in-images,
  .platform-clock-in-button {
    display: inline-block;
    margin-top: 24px;
    width: 70%;
    text-align: left;
  }
  .platform-clock-in-images-item {
    margin: 0 8px 8px 0;
    width: 148px;
    height: 148px;
  }
}
</style>
